import { updateInitialConfig, updateModifiedConfig } from "../../checksumStore";

export const updateCalendarChecksum = (blockData, isInit) => {
  let storeConfig = { ...blockData };
  if (isInit) {
    updateInitialConfig(storeConfig);
  } else {
    updateModifiedConfig(storeConfig);
  }
  return storeConfig;
};
